import { KnowledgeBaseListComponent } from './components/knowledge-base/knowledge-base-list/knowledge-base-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginClientLayoutComponent } from './layouts/login-client-layout/login-client-layout.component';
import { LoginOperatorLayoutComponent } from './layouts/login-operator-layout/login-operator-layout.component';

import { OperatorLayoutComponent } from './layouts/operator-layout/operator-layout.component';
import { ClientLayoutComponent } from './layouts/client-layout/client-layout.component';

import { ClientLoginComponent } from './views/client/client-login/client-login.component';
import { ClientCallListComponent } from './views/client/client-call-list/client-call-list.component';
import { ClientCallDetailsComponent } from './views/client/client-call-details/client-call-details.component';


import { OperatorLoginComponent } from './views/operator/operator-login/operator-login.component';
import { SettingsComponent } from './views/operator/settings/settings.component';
import { OpenCallOperatorComponent } from './views/operator/open-call-operator/open-call-operator.component';
import { HomeOperatorComponent } from './views/operator/home-operator/home-operator.component';
import { ListCallsComponent } from './views/operator/list-calls/list-calls.component';
import { CallCompleteComponent } from './views/operator/call-complete/call-complete.component';

import { AuthGuard } from './guards/auth.guard';
import { AuthOperatorGuard } from './guards/auth-operator.guard';
import { ListBusinessComponent } from './components/list/list-business/list-business.component';
import { AddBusinessComponent } from './components/form/add-business/add-business.component';
import { ListUserComponent } from './components/list/list-user/list-user.component';
import { AddUserComponent } from './components/form/add-user/add-user.component';
import { EditUserComponent } from './components/form/edit-user/edit-user.component';
import { ClientHomeComponent } from './views/client/client-home/client-home.component';
import { ClientProfileComponent } from './views/client/client-profile/client-profile.component';
import { ClientInvoiceListComponent } from './views/client/client-invoice-list/client-invoice-list.component';


const routes: Routes = [
  {
    path: '',
    component: LoginClientLayoutComponent,
    children: [
      {
        path: 'login',
        component: ClientLoginComponent,
      }
    ],
  },
  {
    path: 'cliente',
    component: ClientLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ClientHomeComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'profile',
        component: ClientProfileComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chamados',
        component: ClientCallListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chamados/:identifier',
        component: ClientCallDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'faturas',
        component: ClientInvoiceListComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'operador/login',
    component: LoginOperatorLayoutComponent,
    children: [
      {
        path: 'login',
        component: OperatorLoginComponent,
      }
    ],
  },
  {
    path: 'operador',
    component: OperatorLayoutComponent,
    canActivate: [AuthOperatorGuard],
    children: [
      {
        path: '',
        component: HomeOperatorComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'chamados',
        component: ListCallsComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'chamados/criar',
        component: OpenCallOperatorComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'chamados/:identifier',
        component: CallCompleteComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'configuracoes',
        component: SettingsComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'empresas',
        component: ListBusinessComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'empresas/adicionar',
        component: AddBusinessComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'usuarios',
        component: ListUserComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'usuarios/empresa/:business',
        component: ListUserComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'usuarios/adicionar',
        component: AddUserComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'usuarios/editar/:id',
        component: EditUserComponent,
        canActivate: [AuthOperatorGuard]
      },
      {
        path: 'base',
        component: KnowledgeBaseListComponent,
        canActivate: [AuthOperatorGuard]
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
